
import { Multiselect } from 'vue-multiselect';

export default {
    extends: Multiselect
};
